import React, { useState, useEffect, useRef } from 'react';
import { TypewriterText, MultiLineText } from './components';

// Сворачиваемая панель «Мысли ИИ» (T3 плана streaming-ai-thoughts).
// Мысли приходят через props (T4 подключает к polling), контракт записи:
// { phase, agent, text, label? } — см. api/.../orchestrator/_task_state.py

// Порог «пользователь у нижнего края» для автоскролла
const NEAR_BOTTOM_PX = 48;

const isNearBottom = (el) =>
  el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;


const AiThoughtsPanel = ({ thoughts = [], isProcessing = false }) => {
  const [expanded, setExpanded] = useState(false);
  const listRef = useRef(null);
  // false = пользователь проскроллил вверх — не навязываем автоскролл
  const stickToBottom = useRef(true);

  useEffect(() => {
    const el = listRef.current;
    if (expanded && el && stickToBottom.current) {
      el.scrollTop = el.scrollHeight;
    }
  }, [expanded, thoughts]);

  const handleScroll = () => {
    const el = listRef.current;
    if (el) stickToBottom.current = isNearBottom(el);
  };

  const toggle = () => setExpanded((v) => !v);
  const lastIdx = thoughts.length - 1;

  return (
    <div className="pd-thoughts">
      <button
        type="button"
        className="pd-thoughts__header"
        onClick={toggle}
        aria-expanded={expanded}
      >
        <span className="pd-thoughts__title">
          <span className="pd-thoughts__icon">🧠</span>
          Мысли ИИ
        </span>
        <span className="pd-thoughts__right">
          {isProcessing && <span className="pd-thoughts__dot" />}
          {thoughts.length > 0 && (
            <span className="pd-thoughts__badge">{thoughts.length}</span>
          )}
          <svg
            className={`pd-thoughts__chevron${expanded ? ' pd-thoughts__chevron--open' : ''}`}
            width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      {expanded && (
        <div className="pd-thoughts__body">
          {thoughts.length === 0 ? (
            <div className="pd-thoughts__empty">
              {isProcessing ? 'Думаю…' : 'Ожидаю запрос…'}
            </div>
          ) : (
            <div className="pd-thoughts__list" ref={listRef} onScroll={handleScroll}>
              {thoughts.map((t, i) => (
                <div key={`${t.phase}|${t.agent}|${t.text}`} className="pd-thoughts__item">
                  {t.label && <span className="pd-thoughts__item-label">{t.label}</span>}
                  <div className="pd-thoughts__item-text">
                    {i === lastIdx && isProcessing
                      ? <TypewriterText text={t.text || ''} />
                      : <MultiLineText text={t.text} />}
                  </div>
                  {(t.agent || t.phase) && (
                    <span className="pd-thoughts__item-meta">[{t.agent || t.phase}]</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AiThoughtsPanel;
